import { workflowAnalytics, funnelBarColors } from "@/mocks/workflowsData";

export default function WorkflowAnalyticsSection() {
  const { totalProcessed, autoQualified, droppedLost, avgQualificationTime, funnel } = workflowAnalytics;
  const qualPct = totalProcessed > 0 ? Math.round((autoQualified / totalProcessed) * 100) : 0;
  const lostPct = totalProcessed > 0 ? Math.round((droppedLost / totalProcessed) * 100) : 0;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-semibold text-gray-900">Workflow Performance</h3>
        <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-xs font-medium whitespace-nowrap">This Month</span>
      </div>

      {/* Stat Cards Row */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="bg-indigo-50 rounded-xl p-4">
          <p className="text-xs text-indigo-600 font-medium">Total Leads Processed</p>
          <p className="text-2xl font-bold text-indigo-700 mt-1">{totalProcessed}</p>
        </div>
        <div className="bg-green-50 rounded-xl p-4">
          <p className="text-xs text-green-600 font-medium">Auto-Qualified</p>
          <p className="text-2xl font-bold text-green-700 mt-1">{autoQualified} <span className="text-sm font-normal">({qualPct}%)</span></p>
        </div>
        <div className="bg-red-50 rounded-xl p-4">
          <p className="text-xs text-red-600 font-medium">Dropped / Lost</p>
          <p className="text-2xl font-bold text-red-700 mt-1">{droppedLost} <span className="text-sm font-normal">({lostPct}%)</span></p>
        </div>
        <div className="bg-amber-50 rounded-xl p-4">
          <p className="text-xs text-amber-600 font-medium">Avg Qualification Time</p>
          <p className="text-2xl font-bold text-amber-700 mt-1">{avgQualificationTime}</p>
        </div>
      </div>

      {/* Funnel Chart */}
      <div>
        <h4 className="text-sm font-medium text-gray-700 mb-3">Conversion Funnel</h4>
        <div className="space-y-3">
          {funnel.map((item, idx) => {
            const pct = totalProcessed > 0 ? Math.round((item.count / totalProcessed) * 100) : 0;
            const maxCount = funnel[0].count;
            const barWidth = maxCount > 0 ? Math.round((item.count / maxCount) * 100) : 0;
            return (
              <div key={idx} className="flex items-center gap-3">
                <span className="text-sm text-gray-700 w-40 flex-shrink-0 whitespace-nowrap">{item.label}</span>
                <div className="flex-1 bg-gray-100 rounded-full h-6 overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all duration-500 ${funnelBarColors[item.color]}`}
                    style={{ width: `${barWidth}%` }}
                  />
                </div>
                <span className="text-sm font-medium text-gray-700 w-16 text-right flex-shrink-0 whitespace-nowrap">
                  {item.count} <span className="text-gray-400 text-xs">({pct}%)</span>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}